import type { Brand } from './brandLogos';
import { ICONS, type IconComponent } from '../components/ui/icons';
/** Menu Ferramentas: tipos e ícones compartilhados (lançador e página) */
export interface ToolItem {
  id: 'api-oficial' | 'cobrancas' | 'instagram' | 'cupons' | 'imagens' | 'lead-ads';
  name: string;
  description: string;
  billing: 'credits' | 'included' | 'addon';
  addon?: AddonType;
  ready: boolean;
  active: boolean;
}

/** Add-ons mensais (só a API oficial da Meta) */
export type AddonType = 'META_API';
export const ADDON_TYPES: readonly AddonType[] = ['META_API'];

export interface ToolsOverview {
  tools: ToolItem[];
  balanceCents: number;
  /** Total liberado (contratado + cortesia) */
  addons: Record<AddonType, number>;
  /** Só o contratado na assinatura (o que o botão altera) */
  contracted: Record<AddonType, number>;
  /** Pago com créditos (30 dias) */
  prepaid: Record<AddonType, { quantity: number; until: string | null; autoRenew: boolean }>;
  pricing: {
    addons: Record<AddonType, { label: string; monthly: number; purchasable: boolean }>;
    creditPacksCents: number[];
    minCreditCents: number;
  };
  stripeConfigured: boolean;
  hasSubscription: boolean;
}

/** Ícone de cada ferramenta — nome oficial do Cloudscape. */
export const TOOL_ICONS: Record<ToolItem['id'], IconComponent> = {
  'api-oficial': ICONS.Shield,
  cobrancas: ICONS.CreditCard,
  instagram: ICONS.Camera,
  cupons: ICONS.CreditCard,
  imagens: ICONS.Copy,
  'lead-ads': ICONS.InviteUser,
};

/** Ferramentas de uma marca: mostram o logo (logo.dev) no lugar do ícone */
export const TOOL_BRANDS: Partial<Record<ToolItem['id'], Brand>> = {
  instagram: 'instagram',
  'api-oficial': 'meta',
  'lead-ads': 'facebook',
};

/** Só as ferramentas que o front conhece (descarta ids antigos que o servidor ainda mande) */
export const knownTools = (tools: ToolItem[]) => tools.filter((t) => t.id in TOOL_ICONS);

export const BILLING_LABEL: Record<ToolItem['billing'], string> = {
  credits: 'Créditos',
  included: 'Incluso',
  addon: 'Add-on mensal',
};

export const brlFromCents = (cents: number) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
